function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Math, Object, annotations, utcOffset) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['annotations-ui'] = function(annotations) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const POPOVER_MAX_WIDTH = 350;;
        __jade_nodes = __jade_nodes.concat((annotations.activeAnnotationButton) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
            "attrs": __vjadeStringifyAttrsIfObj({
              open: !annotations.activeAnnotationPopupClosing,
              direction: `up`,
            }),
            "on": {
              change: $helpers.annotations.popupChange,
            },
            "style": {
              left: `${Math.max(annotations.activeAnnotationButton.x, POPOVER_MAX_WIDTH / 2)}px`,
              bottom: `${annotations.activeAnnotationButton.topOfButtonToBottomOfChart}px`,
              transform: `translateX(calc(-50% + ${annotations.activeAnnotationButton.width / 2}px))`,
              'max-width': POPOVER_MAX_WIDTH,
            },
            "key": `annotation-popup-${annotations.activeAnnotationButton.timestampMs}`,
            "class": {
              'line-chart-annotation-popup': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((annotations.creatingAnnotation) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("create-annotation-form", {
                "key": annotations.createAnnotationDate,
                "attrs": __vjadeStringifyAttrsIfObj({
                  'utc-offset': utcOffset,
                  'date': annotations.createAnnotationDate,
                }),
                "on": {
                  annotationCreated: $helpers.annotations.add,
                  closeAnnotationPopup: $helpers.annotations.close,
                },
              }));;
              return __jade_nodes
            }).call(this)) : (annotations.viewingAnnotations) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("view-annotations-list", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  'active-annotation': annotations.activeAnnotationButton,
                  'active-annotation-group': annotations.visibleAnnotations.get(annotations.activeAnnotationButton.timestampMs),
                  'annotation-description-draft': annotations.annotationDescriptionDraft,
                  'can-write-annotations': $attr('show-annotations'),
                  'editing-annotation': annotations.editingAnnotation,
                  'deleting-annotation': annotations.deletingAnnotation,
                  'time-unit': $attr('trend-unit'),
                }),
                "on": {
                  closeAnnotationPopup: $helpers.annotations.close,
                  showCreateAnnotation: $helpers.annotations.showCreate,
                  editAnnotation: $helpers.annotations.edit,
                  deleteAnnotation: $helpers.annotations.delete,
                  updateAnnotationDescriptionDraft: $helpers.annotations.updateDescriptionDraft,
                  saveAnnotation: $helpers.annotations.save,
                  editCanceled: $helpers.annotations.editCanceled,
                  deleteConfirmed: $helpers.annotations.deleteConfirmed,
                  deleteCanceled: $helpers.annotations.deleteCanceled
                },
              }));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : (annotations.activeAnnotationPreview) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
            "attrs": __vjadeStringifyAttrsIfObj({
              open: true,
              direction: `up`,
            }),
            "style": {
              left: `${Math.max(annotations.activeAnnotationPreview.x, POPOVER_MAX_WIDTH / 2)}px`,
              bottom: `${annotations.activeAnnotationPreview.topOfButtonToBottomOfChart}px`,
              transform: `translateX(calc(-50% + ${annotations.activeAnnotationPreview.width / 2}px))`,
              'max-width': POPOVER_MAX_WIDTH,
            },
            "key": `annotation-preview-${annotations.activeAnnotationPreview.timestampMs}`,
            "class": {
              'line-chart-annotation-popup': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("view-annotations-list", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'active-annotation': annotations.activeAnnotationPreview,
                'active-annotation-group': annotations.visibleAnnotations.get(annotations.activeAnnotationPreview.timestampMs),
                'time-unit': $attr('trend-unit'),
                type: 'preview',
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((annotations) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(jade_mixins['annotations-ui'].call(this, annotations));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Math" in locals ? locals.Math : typeof Math !== "undefined" ? Math : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "annotations" in locals ? locals.annotations : typeof annotations !== "undefined" ? annotations : undefined, "utcOffset" in locals ? locals.utcOffset : typeof utcOffset !== "undefined" ? utcOffset : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;